// Тактильный отклик по клику. Взято из Летописи.
// Android/Chrome: navigator.vibrate. iOS 17.4+: hidden <input type="checkbox" switch>
// — при переключении этого элемента iOS даёт один короткий haptic.

type HapticPattern = number | number[]

let singletonCheckbox: HTMLInputElement | null = null
let singletonLabel: HTMLLabelElement | null = null

const isTouchDevice = typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches
const hasVibrate = typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function'

function ensureSingletonElements(): { input: HTMLInputElement; label: HTMLLabelElement } | null {
  if (singletonCheckbox && singletonLabel) return { input: singletonCheckbox, label: singletonLabel }
  if (typeof document === 'undefined') return null

  const input = document.createElement('input')
  input.type = 'checkbox'
  input.setAttribute('switch', '')
  input.id = '__haptic_checkbox'
  input.setAttribute('aria-hidden', 'true')
  input.tabIndex = -1
  Object.assign(input.style, { position: 'fixed', left: '-9999px', top: '-9999px', opacity: '0', pointerEvents: 'none' })

  const label = document.createElement('label')
  label.htmlFor = input.id
  label.setAttribute('aria-hidden', 'true')
  Object.assign(label.style, { position: 'fixed', left: '-9999px', top: '-9999px' })

  const stop = (e: Event) => { e.stopPropagation(); e.stopImmediatePropagation() }
  label.addEventListener('click', stop)
  input.addEventListener('click', stop)

  document.body.appendChild(input)
  document.body.appendChild(label)

  singletonCheckbox = input
  singletonLabel = label
  return { input, label }
}

if (typeof document !== 'undefined' && isTouchDevice && !hasVibrate) {
  // ES-модули выполняются после парсинга DOM — document.body гарантированно есть.
  ensureSingletonElements()
  document.addEventListener('touchstart', () => ensureSingletonElements(), { once: true, passive: true })
}

function vibrateIos(): void {
  const els = ensureSingletonElements()
  if (!els) return
  els.label.click()
}

function triggerHaptic(pattern: HapticPattern): void {
  if (!isTouchDevice) return
  if (hasVibrate && navigator.vibrate(pattern)) return

  // iOS fallback: один клик чекбокса = один пульс
  if (Array.isArray(pattern)) {
    const vibs = pattern.filter((_, i) => i % 2 === 0)
    vibs.forEach((_, i) => {
      if (i === 0) vibrateIos()
      else {
        const delay = pattern.slice(0, i * 2).reduce((a, b) => a + b, 0)
        setTimeout(vibrateIos, delay)
      }
    })
  } else {
    vibrateIos()
  }
}

export const haptic = {
  tap()     { triggerHaptic(15) },
  success() { triggerHaptic([30, 50, 30]) },
  warning() { triggerHaptic([30, 50, 30, 50, 30]) },
}

// Глобально — любой клик по <button> или <a> даёт tap-haptic.
// Capture-фаза, чтобы кнопки с @click.stop (которые вызывают
// event.stopPropagation()) не глушили haptic.
if (typeof document !== 'undefined' && isTouchDevice) {
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement | null
    if (target?.closest('button, a')) haptic.tap()
  }, { capture: true })
}
